<template>
    <v-card flat tile>
        <SwitchCategoryDialog :show="showSwitchDialog" :keywords="selectedRows" @close="showSwitchDialog = false" @catUpdated="catUpdated"></SwitchCategoryDialog>

        <DeleteDialog :deleteDialog="deleteDialog" :selectedDeleteItem="''" :deleteLabel="deleteLabel" :loading="false" @delete="deleteKeywords" @close="deleteDialog = false"></DeleteDialog>

        <ColumnSwitchDialog :headers="headers" :dialog="columnDialog" @close="columnDialog = false" @headerOrderChanged="headerOrderChanged"></ColumnSwitchDialog>

        <v-slide-x-reverse-transition hide-on-leave>
            <div style="position: relative" v-if="selectedRows.length">
                <div style="position: absolute; z-index: 5; top: -38px; right: 16px">
                    <v-chip outlined small class="mr-2 pl-4 pr-1">
                        {{ selectedRows.length }} SELECTED
                        <v-btn class="mx-1" x-small icon @click="selectedRows = []"><v-icon x-small>mdi-close</v-icon></v-btn>
                    </v-chip>
                    <v-divider vertical></v-divider>
                    <v-btn elevation="0" :disabled="$store.state.monitoring_suite_group.id == 2" color="primary" outlined rounded small class="mr-2" @click="showSwitchDialog = true">
                        <v-icon class="mr-1" small>mdi-swap-horizontal</v-icon>category</v-btn
                    >
                    <v-btn elevation="0" :disabled="$store.state.monitoring_suite_group.id == 2" outlined rounded color="error" small @click="deleteDialog = true">
                        <v-icon class="mr-1" small>mdi-delete</v-icon> delete</v-btn
                    >
                </div>
            </div>
        </v-slide-x-reverse-transition>

        <OpenSerpDialog :task_id="selectedItem.task_id"></OpenSerpDialog>
        <v-slide-x-reverse-transition hide-on-leave>
            <div style="position: relative" v-if="!selectedRows.length">
                <div style="position: absolute; z-index: 5; top: -38px; right: 16px">
                    <div style="display: inline-flex">
                        <filter-menu :fields="filterFields" @filtersUpdated="filtersUpdated" :dense="true"></filter-menu>
                    </div>
                </div>
            </div>
        </v-slide-x-reverse-transition>

        <v-data-table
            :headers="visibleHeaders"
            :items="trends"
            :loading="loading"
            :sort-desc.sync="sortDesc"
            :sort-by.sync="sortBy"
            :page.sync="page"
            :items-per-page.sync="itemsPerPage"
            :server-items-length="count"
            :footer-props="footerProps"
            @update:options="fetchTrends"
            v-model="selectedRows"
            @click:row="onRowClick"
            fixed-header
            height="70vh"
            id="trendsTable"
            item-key="_id"
            class="elevation-0">
            <template v-for="(header_entry, index) in headers" v-slot:[`header.${header_entry.value}`]="{ header }">
                <span :key="index">
                    <span v-bind:style="{ width: header.width }">
                        <v-btn
                            small
                            v-if="index == 0"
                            class="mb-4 mr-2 mt-3"
                            icon
                            color="grey"
                            @click="
                                (e) => {
                                    e.stopPropagation()
                                    columnDialog = true
                                }
                            "
                            ><v-icon size="19px">mdi-tune</v-icon></v-btn
                        >

                        <v-tooltip max-width="250" top :disabled="header.tooltip ? false : true">
                            <template v-slot:activator="{ on }">
                                <span v-on="on" style="white-space: nowrap; text-transform: uppercase; font-weight: 500">
                                    {{ header.text }}
                                    <v-icon class="questionIcon" v-if="header.tooltip" x-small>mdi-help-circle-outline</v-icon>
                                </span>
                            </template>
                            <span>
                                <div v-if="header.value == 'keyword_intent'">
                                    <div class="mt-2">
                                        <span><b> Search Intent:</b> </span>
                                    </div>
                                    {{ header.tooltip }}
                                    <div class="mt-2">
                                        <span><b> Intentions:</b> </span>
                                    </div>
                                    <span v-for="(icon, intent) in intent_icons" :key="intent">
                                        <v-chip class="mr-1 mb-1 mt-1" color="primary">
                                            <v-icon size="16px" class="mr-1">{{ icon }}</v-icon> {{ intent }}
                                        </v-chip>
                                        <div>
                                            <p>{{ intentTooltips[intent] }}</p>
                                        </div>
                                    </span>
                                </div>
                                <div v-else>
                                    <v-row no-gutters>
                                        <div cols="12"><v-icon color="white">mdi-help-circle-outline</v-icon></div>
                                    </v-row>
                                    {{ header.tooltip }}
                                </div>
                            </span>
                        </v-tooltip>
                    </span>
                </span>
            </template>
            <!-- Keyword Column -->
            <template v-slot:item.keyword="{ item }">
                <div :class="!item.blur ? 'py-2' : 'py-2 blur'">
                    <span class="rtd pl-2">
                        {{ item.keyword }}
                        <!-- <v-icon @click="selectedItem = item" x-small class="px-0">mdi-tab-search</v-icon> -->
                    </span>
                    <div style="white-space: nowrap" v-if="item.category_id">
                        <v-btn icon x-small @click="showAllCategories = !showAllCategories"
                            ><v-icon x-small>{{ showAllCategories ? "mdi-chevron-right" : "mdi-chevron-left" }}</v-icon></v-btn
                        >
                        <span v-if="item.category_id && showAllCategories" style="white-space: nowrap">
                            <span v-for="(cat, index) in item.category_id.split(';')" :key="cat">
                                <span v-if="cat">
                                    <v-icon v-if="index" x-small class="px-0">mdi-chevron-right</v-icon>
                                    <v-chip x-small @click="!item.blur ? $emit('setCategory', item.category_id, index) : null"> {{ cat }}</v-chip>
                                </span>
                            </span>
                        </span>
                        <span v-else>
                            <v-chip x-small @click="!item.blur ? $emit('setCategory', item.category_id, item.category_id.split(';').filter((c) => c.length).length - 1) : null">
                                {{ item.category_id.split(";").filter((c) => c.length)[item.category_id.split(";").filter((c) => c.length).length - 1] }}</v-chip
                            >
                        </span>
                    </div>
                </div>
            </template>
            <!-- Latest Monthly_searches Column -->
            <template v-slot:item.movingavg_short="{ item }">
                <!-- {{ item.ads_data.monthly_searches }} -->
                <div>
                    <!-- <v-sparkline
                        class="my-auto"
                        :value="item.sparkline"
                        :gradient="gradient"
                        smooth="4"
                        padding="6"
                        line-width="6"
                        stroke-linecap="round"
                        gradient-direction="top"
                        auto-draw></v-sparkline> -->
                    <v-row no-gutters class="d-flex"
                        ><v-col class="d-flex my-auto" style="position: relative">
                            <v-sparkline
                                class="my-auto"
                                style="max-width: 110px; max-height: 40px"
                                id="sparkline"
                                color="primary"
                                :value="item.sparkline"
                                padding="2"
                                smooth="20"
                                gradient-direction="top"
                                auto-draw
                                :fill="false"></v-sparkline>
                            <v-sparkline
                                class="my-auto"
                                style="max-width: 110px; max-height: 40px; position: absolute"
                                id="sparkline"
                                color="primary"
                                :value="item.sparkline"
                                :gradient="gradient"
                                padding="2"
                                smooth="20"
                                gradient-direction="top"
                                auto-draw
                                :fill="true"></v-sparkline>
                        </v-col>
                        <span class="my-auto">
                            <v-chip class="ml-2 qchip" color="grey darken-1" outlined>
                                <v-icon v-if="item.movingavg_short !== '0.00'" class="mr-1" small :color="item.movingavg_short < 0 ? 'red' : 'green'">{{
                                    item.movingavg_short < 0 ? "mdi-arrow-down" : "mdi-arrow-up"
                                }}</v-icon>
                                <v-icon v-else class="mr-1" small color="grey darken-2">mdi-arrow-right</v-icon>
                                <span class="my-auto">{{ item.movingavg_short ? item.movingavg_short.toFixed(2) : 0 }}%</span>
                            </v-chip>
                        </span>
                    </v-row>
                </div>
            </template>
            <template v-slot:item.keyword_intent="{ item }">
                <div style="display: inline-flex" v-if="item.sorted_search_intent">
                    <!-- Haupt-Intent -->
                    <span class="pa-1 d-flex">
                        <!--    <v-chip outlined class="qchip" color="primary" style="color: grey !important">
                            <v-icon class="mr-1" size="16px" color="primary">{{ intent_icons[item.sorted_search_intent[0][0]] }}</v-icon>
                            {{ Math.ceil(item.sorted_search_intent[0][1]) + "%" }}
                        </v-chip>-->
                        <v-tooltip max-width="250" color="primary" top>
                            <template v-slot:activator="{ on }">
                                <v-progress-linear
                                    v-on="on"
                                    style="border-radius: 16px; font-size: 14px; width: 70px; margin: auto; opacity: 0.8"
                                    class="white--text intent"
                                    rounded
                                    :value="item.sorted_search_intent[0][1]"
                                    color="primary"
                                    height="32">
                                    <v-icon class="mr-1" size="16px" color="white">{{ intent_icons[item.sorted_search_intent[0][0]] }}</v-icon>
                                    {{ Math.ceil(item.sorted_search_intent[0][1]) + "%" }}
                                </v-progress-linear>
                            </template>
                            <span> {{ item.sorted_search_intent[0][0] }}</span>
                        </v-tooltip>
                    </span>
                    <v-slide-x-transition>
                        <span v-if="show_secondary_intents" style="display: inline-flex">
                            <span v-for="(intent, index) in item.sorted_search_intent.slice(1)" :key="index" class="pa-1">
                                <!-- Alle bis auf den ersten Intent -->
                                <!--  <v-chip outlined class="qchip" color="primary" style="color: grey !important">
                                    <v-icon class="mr-1" size="16px" color="primary">{{ intent_icons[intent[0]] }}</v-icon>
                                    {{ Math.ceil(intent[1]) + "%" }}
                                </v-chip> -->
                                <v-tooltip max-width="250" color="primary" top>
                                    <template v-slot:activator="{ on }">
                                        <v-progress-linear
                                            style="border-radius: 15px; font-size: 14px; width: 70px; margin: auto; opacity: 0.8"
                                            v-on="on"
                                            class="white--text intent"
                                            rounded
                                            :value="intent[1]"
                                            color="primary"
                                            height="32">
                                            <v-icon class="mr-1" size="16px" color="white">{{ intent_icons[intent[0]] }}</v-icon>
                                            {{ Math.ceil(intent[1]) + "%" }}
                                        </v-progress-linear>
                                    </template>
                                    <span>{{ intent[0] }} </span>
                                </v-tooltip>
                            </span>
                        </span>
                    </v-slide-x-transition>
                    <v-btn
                        @click="
                            (e) => {
                                e.stopPropagation()
                                show_secondary_intents = !show_secondary_intents
                            }
                        "
                        icon
                        class="ma-auto">
                        <v-icon>{{ show_secondary_intents ? "mdi-chevron-left" : "mdi-chevron-right" }}</v-icon>
                    </v-btn>
                </div>
            </template>
            <!-- Latest Year-Month Column -->
            <template v-slot:item.latestYearMonth="{ item }">
                <v-chip outlined class="qchip" color="primary"> {{ item.latestYearMonth ? $helpers.formatNumber(item.latestYearMonth.search_volume) : "no data" }}</v-chip>
            </template>
            <!-- Last Year-Month Column -->
            <template v-slot:item.lastYearMonth="{ item }">
                <v-chip outlined class="qchip" color="primary"> {{ item.lastYearMonth ? $helpers.formatNumber(item.lastYearMonth.search_volume) : "no data" }}</v-chip>
            </template>
            <!-- amazon_search_volume Column -->
            <template v-slot:item.amazon_search_volume="{ item }">
                <v-chip outlined class="qchip" color="primary"> {{ item.amazon_search_volume ? $helpers.formatNumber(item.amazon_search_volume * 12) : "no data" }}</v-chip>
            </template>
            <!-- internal_search_volume Column -->
            <template v-slot:item.internal_search_volume="{ item }">
                <div class="d-flex align-center" style="white-space: nowrap">
                    <v-chip outlined class="qchip" color="primary">
                        {{ item.internal_search_volume !== undefined && item.internal_search_volume !== null ? $helpers.formatNumber(item.internal_search_volume) : "no data" }}
                    </v-chip>
                    <span
                        v-if="
                            item.internal_search_volume !== undefined &&
                            item.internal_search_volume !== null &&
                            item.internal_search_volume_prev !== undefined &&
                            item.internal_search_volume_prev !== null &&
                            item.internal_search_volume_prev > 0
                        "
                        v-bind="(internalSvChange = { change: item.internal_search_volume - item.internal_search_volume_prev })"
                        class="internal-sv-change ml-1">
                        <v-icon size="14" v-if="internalSvChange.change > 0" color="success">mdi-menu-up</v-icon>
                        <v-icon size="14" v-else-if="internalSvChange.change < 0" color="error">mdi-menu-down</v-icon>
                        <span v-else class="internal-sv-change__dash">–</span>
                        <span class="internal-sv-change__value"> {{ Math.abs((internalSvChange.change / item.internal_search_volume_prev) * 100).toFixed(1) }}% </span>
                    </span>
                </div>
            </template>
            <!-- avg_search_volume Column -->
            <template v-slot:item.avg_search_volume="{ item }">
                <v-chip outlined class="qchip" color="primary"> {{ item.avg_search_volume ? $helpers.formatNumber(item.avg_search_volume) : "no data" }}</v-chip>
            </template>
            <!-- latest_12_month_search_volume Column -->
            <template v-slot:item.latest_12_month_search_volume="{ item }">
                <v-chip outlined class="qchip" color="primary"> {{ item.latest_12_month_search_volume ? $helpers.formatNumber(item.latest_12_month_search_volume) : "no data" }}</v-chip>
            </template>
            <!-- prev_12_month_search_volume Column -->
            <template v-slot:item.prev_12_month_search_volume="{ item }">
                <v-chip outlined class="qchip" color="primary"> {{ item.prev_12_month_search_volume ? $helpers.formatNumber(item.prev_12_month_search_volume) : "no data" }}</v-chip>
            </template>
            <template v-slot:item.year_change_percent="{ item }">
                <v-chip outlined class="qchip" :color="item.year_change_percent > 0 ? 'green darken-2' : item.year_change_percent < 0 ? 'red darken-2' : 'grey darken-2'">
                    <v-icon class="mr-1" small :color="item.year_change_percent > 0 ? 'green darken-2' : item.year_change_percent < 0 ? 'red darken-2' : 'grey darken-2'">
                        {{ item.year_change_percent > 0 ? "mdi-arrow-up" : item.year_change_percent < 0 ? "mdi-arrow-down" : "mdi-arrow-right" }}
                    </v-icon>
                    {{ item.year_change_percent !== undefined && item.year_change_percent !== null ? item.year_change_percent.toFixed(2) + "%" : "no data" }}
                </v-chip>
            </template>
            <template v-slot:item.month_change_percent="{ item }">
                <v-chip outlined class="qchip" :color="item.month_change_percent > 0 ? 'green darken-2' : item.month_change_percent < 0 ? 'red darken-2' : 'grey darken-2'">
                    <v-icon class="mr-1" small :color="item.month_change_percent > 0 ? 'green darken-2' : item.month_change_percent < 0 ? 'red darken-2' : 'grey darken-2'">
                        {{ item.month_change_percent > 0 ? "mdi-arrow-up" : item.month_change_percent < 0 ? "mdi-arrow-down" : "mdi-arrow-right" }}
                    </v-icon>
                    {{ item.month_change_percent !== undefined && item.month_change_percent !== null ? item.month_change_percent.toFixed(2) + "%" : "no data" }}
                </v-chip>
            </template>
            <template v-slot:item.year_change_absolute="{ item }">
                <v-chip outlined class="qchip" :color="item.year_change_absolute > 0 ? 'green darken-2' : item.year_change_absolute < 0 ? 'red darken-2' : 'grey darken-2'">
                    <v-icon class="mr-1" small :color="item.year_change_absolute > 0 ? 'green darken-2' : item.year_change_absolute < 0 ? 'red darken-2' : 'grey darken-2'">
                        {{ item.year_change_absolute > 0 ? "mdi-arrow-up" : item.year_change_absolute < 0 ? "mdi-arrow-down" : "mdi-arrow-right" }}
                    </v-icon>
                    {{ item.year_change_absolute !== undefined && item.year_change_absolute !== null ? $helpers.formatNumber(item.year_change_absolute) : "no data" }}
                </v-chip>
            </template>
            <template v-slot:item.month_change_absolute="{ item }">
                <v-chip outlined class="qchip" :color="item.month_change_absolute > 0 ? 'green darken-2' : item.month_change_absolute < 0 ? 'red darken-2' : 'grey darken-2'">
                    <v-icon class="mr-1" small :color="item.month_change_absolute > 0 ? 'green darken-2' : item.month_change_absolute < 0 ? 'red darken-2' : 'grey darken-2'">
                        {{ item.month_change_absolute > 0 ? "mdi-arrow-up" : item.month_change_absolute < 0 ? "mdi-arrow-down" : "mdi-arrow-right" }}
                    </v-icon>
                    {{ item.month_change_absolute !== undefined && item.month_change_absolute !== null ? $helpers.formatNumber(item.month_change_absolute) : "no data" }}
                </v-chip>
            </template>

            <!-- Short-Term Trend Column -->
            <!-- <template v-slot:item.short_term_trend="{ item }"> {{ item.short_term_trend.toFixed(2) }}% </template> -->
        </v-data-table>
    </v-card>
</template>

<script>
    import monitoringTaxonomy from "@/mixins/monitoringTaxonomy"
    import DeleteDialog from "../dialogs/DeleteDialog.vue"
    import SwitchCategoryDialog from "./SwitchCategoryDialog"
    import OpenSerpDialog from "../../components/dialogs/OpenSerpDialog.vue"
    import FilterMenu from "./FilterMenu"
    import ColumnSwitchDialog from "../dialogs/ColumnSwitchDialog.vue"

    export default {
        mixins: [monitoringTaxonomy],
        components: {
            DeleteDialog,
            SwitchCategoryDialog,
            OpenSerpDialog,
            FilterMenu,
            ColumnSwitchDialog
        },
        props: {
            search: {
                type: String
            },
            category_id: {
                type: String
            },
            project_domain: {
                type: String
            },
            exportData: {
                type: Number
            }
        },
        data() {
            return {
                columnDialog: false,
                show_intents: false,
                show_amazon_sv: false,
                show_internal_sv: false,
                show_secondary_intents: false,
                intentTooltips: {
                    informational: "Looking for information on a specific topic, such as “what is SEO?”",
                    navigational: "Navigating to a certain site or page, for instance, “Facebook login page”.",
                    commercial: "Conducting a commercial investigation, that is, researching products or services before making a decision on what to invest in, such as “best SEO tools”.",
                    transactional: "Making a specific purchase, for example, “buy SEO software”."
                },
                intent_icons: { informational: "mdi-information-outline", navigational: "mdi-navigation-outline", commercial: "mdi-shopping-search-outline", transactional: "mdi-shopping-outline" },
                showSwitchDialog: false,
                deleteDialog: false,
                selectedRows: [],
                selectedItem: {},
                showAllCategories: false,
                count: 0,
                loading: false,
                sortDesc: true,
                sortBy: ["movingavg_short"],
                page: 1,
                itemsPerPage: 25,
                pagination: {},
                trends: [],
                gradient: [this.$vuetify.theme.themes.light.sparklineGradient1, this.$vuetify.theme.themes.light.sparklineGradient2, this.$vuetify.theme.themes.light.sparklineGradient3],
                filter: [],
                headersData: [
                    { text: "Keyword", value: "keyword", tooltip: "", filterable: false, visible: true },

                    {
                        text: "Search Trend",
                        value: "movingavg_short",
                        tooltip: "Shows how the the average search volume of the past 2 months compares to the average search volume of the past 12 months.",
                        align: "end",
                        visible: true,
                        width: "250px"
                    },
                    {
                        text: "Google Searches (AVG)",
                        value: "avg_search_volume",
                        sortable: true,
                        visible: false,
                        align: "end",
                        tooltip: "The average monthly search volume on google for the keyword."
                    },
                    {
                        text: "Amazon Searches (Yearly)",
                        value: "amazon_search_volume",
                        sortable: true,
                        visible: true,
                        align: "end",
                        tooltip: "The yearly search volume on Amazon for the keyword."
                    },
                    {
                        text: "Internal Search Volume (Yearly)",
                        value: "internal_search_volume",
                        sortable: true,
                        visible: true,
                        align: "end",
                        tooltip: "The latest internal search volume for the keyword from the matched internal searches project."
                    },
                    { id: 1, text: "Google Searches (Current Year-Month)", value: "latestYearMonth", tooltip: "Shows the search volume of the latest month.", align: "end", visible: true },
                    { id: 2, text: "Google Searches (Previous Year-Month)", value: "lastYearMonth", tooltip: "Shows the search volume of the same month from last year.", align: "end", visible: true },

                    {
                        text: "Month Change (%)",
                        value: "month_change_percent",
                        sortable: true,
                        visible: false,
                        align: "end",
                        tooltip: "Change in percent of the google search volume in the last month compared to the same month of the previous year."
                    },
                    {
                        text: "Month Change (abs)",
                        value: "month_change_absolute",
                        sortable: true,
                        visible: true,
                        align: "end",
                        tooltip: "Absolute change of the current month compared to the same month of the previous year."
                    },
                    {
                        text: "Google Searches (Current 12 Months)",
                        value: "latest_12_month_search_volume",
                        sortable: true,
                        visible: false,
                        align: "end",
                        tooltip: "The commulated search volume of the last 12 months on google for the keyword."
                    },
                    {
                        text: "Google Searches (Previous 12 Months)",
                        value: "prev_12_month_search_volume",
                        sortable: true,
                        visible: false,
                        align: "end",
                        tooltip: "The commulated search volume of the previous 12 months on google for the keyword."
                    },
                    {
                        text: "Year Change (%)",
                        value: "year_change_percent",
                        sortable: true,
                        visible: false,
                        align: "end",
                        tooltip: "Change in percent of the google search volume in the last 12 months compared to the previous 12 months."
                    },
                    {
                        text: "Year Change (ABS)",
                        value: "year_change_absolute",
                        sortable: true,
                        visible: true,
                        align: "end",
                        tooltip: "Absolute change of the search volume in the last 12 months compared to the previous 12 months."
                    },
                    {
                        text: "Search Intent",
                        value: "keyword_intent",
                        sortable: false,
                        visible: true,
                        align: "end",
                        tooltip: "The search intent refers to the user’s motivation behind a search query."
                    }
                ]
            }
        },
        computed: {
            headers: {
                get() {
                    let h = [...this.headersData]

                    if (!this.show_intents) {
                        h = h.filter((header) => header.value !== "keyword_intent")
                    }
                    if (!this.svColumnsEnabledForCompany) {
                        h = h.filter((header) => header.value !== "amazon_search_volume")
                        h = h.filter((header) => header.value !== "internal_search_volume")
                    }
                    return h
                },
                set(newHeaders) {
                    this.headersData = newHeaders
                }
            },
            visibleHeaders() {
                return this.headers.filter((header) => header.visible !== false)
            },
            deleteLabel() {
                let str = ""
                let count = this.selectedRows.length
                return str + count + " Keyword(s) permanently?"
            },
            filterFields() {
                let filterFields = [
                    { name: "Keyword", type: "text", key: "keyword" },
                    { name: "Category", type: "text", key: "category_ids" },
                    { name: "Trend", type: "number", key: "movingavg_short" },
                    { name: "Internal Search Volume", type: "number", key: "internal_search_volume" },
                    { id: 1, name: "Current Year-Month", type: "number", key: "ads_data.monthly_searches.0.search_volume" },
                    { id: 2, name: "Previous Year-Month", type: "number", key: "ads_data.monthly_searches.11.search_volume" }
                ]
                if (!this.categorized_project) {
                    filterFields.splice(1, 1)
                }
                if (this.show_intents) {
                    Object.keys(this.intent_icons).map((intent) => {
                        let intentheader = {
                            name: "Search Intent - " + intent,
                            key: "search_intent." + intent,
                            type: "number"
                        }
                        filterFields.push(intentheader)
                    })
                }
                return filterFields
            },
            footerProps() {
                let footerProps = {
                    itemsPerPageOptions: [10, 25, 50, 100],
                    showFirstLastPage: true
                }
                return footerProps
            },
            company_id() {
                return this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
            },
            svColumnsEnabledForCompany() {
                return ["1547", "1780"].includes(String(this.company_id))
            }
        },
        methods: {
            headerOrderChanged(changedHeaders) {
                this.headersData = [...changedHeaders]
            },
            filtersUpdated(filters) {
                console.log(filters)
                this.filters = filters
                this.fetchTrends({
                    sortDesc: this.sortDesc,
                    sortBy: this.sortBy,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage
                })
            },
            async enrichInternalSearchVolume(trends) {
                try {
                    if (!this.svColumnsEnabledForCompany) return
                    if (!Array.isArray(trends) || !trends.length) return

                    const projectsUrl = process.env.VUE_APP_APIURL + "/internal-searches/projects"
                    const projectsResponse = await this.$helpers.axiosPost(projectsUrl, { company_id: localStorage.company_id })
                    const projects = projectsResponse && projectsResponse.data && projectsResponse.data.projects ? projectsResponse.data.projects : []
                    if (!projects.length) return

                    const normalizeDomain = (value) =>
                        String(value || "")
                            .toLowerCase()
                            .trim()
                            .replace(/^https?:\/\//, "")
                            .replace(/^www\./, "")
                            .replace(/\/.*$/, "")

                    const targetDomain = normalizeDomain(this.project_domain)
                    let selectedProject = projects.find((p) => normalizeDomain(p.domain) === targetDomain) || projects[0]
                    if (!selectedProject || !selectedProject._id) return

                    const normalizeKeywordKey = (value) =>
                        String(value || "")
                            .toLowerCase()
                            .trim()
                            .replace(/\s+/g, " ")

                    const searchesUrl = process.env.VUE_APP_APIURL + "/internal-searches/project/keywords/searches"
                    const searchesResponse = await this.$helpers.axiosPost(searchesUrl, {
                        company_id: localStorage.company_id,
                        project_id: selectedProject._id,
                        keywords: trends.map((t) => t.keyword)
                    })

                    const keywordSearches = Array.isArray(searchesResponse.data) ? searchesResponse.data : []
                    const svByKeyword = {}
                    keywordSearches.forEach((entry) => {
                        if (!entry || !entry._id || !Array.isArray(entry.data)) return
                        const sortedData = [...entry.data].sort((a, b) => String(b.importDate || "").localeCompare(String(a.importDate || "")))
                        const current = sortedData[0]
                        const previous = sortedData[1]
                        svByKeyword[normalizeKeywordKey(entry._id)] = {
                            current: current && current.search_volume !== undefined ? current.search_volume : null,
                            previous: previous && previous.search_volume !== undefined ? previous.search_volume : null
                        }
                    })

                    trends.forEach((trend) => {
                        const entry = svByKeyword[normalizeKeywordKey(trend.keyword)]
                        if (!entry) return
                        if (entry.current !== null && entry.current !== undefined) {
                            trend.internal_search_volume = entry.current
                            this.show_internal_sv = true
                        }
                        trend.internal_search_volume_prev = entry.previous
                    })
                } catch (error) {
                    console.log(error)
                }
            },
            async fetchTrends(tableOptions) {
                try {
                    let sort = this.getSortObject(tableOptions)
                    this.loading = true
                    const requestData = {
                        company_id: localStorage.company_id,
                        company_status: this.$store.state.company_status_monitoring_suite,
                        user_id: localStorage.id,
                        project_id: this.$route.params.id,
                        category_id: this.category_id ? this.category_id : null,
                        sortDesc: tableOptions.sortDesc[0] ? -1 : 1,
                        start: (tableOptions.page - 1) * tableOptions.itemsPerPage,
                        limit: tableOptions.itemsPerPage,
                        sort: sort,
                        search: this.search,
                        filters: this.filters
                    }
                    const url =
                        (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                            this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                        ) == -1
                            ? process.env.VUE_APP_MONITORING_API_URL
                            : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/get/frontend/trends/v2"
                    const response = await this.$helpers.axiosPost(url, this.withTaxonomy(requestData))
                    console.log(response.data)
                    this.trends = response.data.trends.map((entry) => {
                        if (entry.ads_data.monthly_searches) {
                            entry.sparkline = entry.ads_data.monthly_searches.reverse().map((searchdata) => searchdata.search_volume) || 0
                            entry.latestYearMonth = entry.ads_data.monthly_searches[entry.ads_data.monthly_searches.length - 1] || 0
                            entry.lastYearMonth = entry.ads_data.monthly_searches[entry.ads_data.monthly_searches.length - 13] || 0
                            if (entry.search_intent) {
                                this.show_intents = true
                                entry.sorted_search_intent = this.sortIntent(JSON.parse(JSON.stringify(entry.search_intent)))
                            }
                            if (entry.amazon_search_volume) {
                                this.show_amazon_sv = true
                            }
                            if (entry.internal_search_volume !== undefined && entry.internal_search_volume !== null) {
                                this.show_internal_sv = true
                            }
                        }
                        return entry
                    })
                    await this.enrichInternalSearchVolume(this.trends)
                    if (this.trends.some((entry) => entry.year_change_percent !== undefined)) {
                        let h = this.headersData.find((h) => h.value === "year_change_percent")
                        if (h) h.visible = true
                    }
                    if (this.trends.some((entry) => entry.month_change_percent !== undefined)) {
                        let h = this.headersData.find((h) => h.value === "month_change_percent")
                        if (h) h.visible = true
                    }
                    this.setHeaderDateString()
                    this.count = response.data.totalCount || 100

                    this.loading = false
                } catch (error) {
                    console.error(error)
                    this.loading = false
                }
            },
            sortIntent(intent) {
                return Object.entries(intent).sort(([, valueA], [, valueB]) => {
                    if (valueA === null && valueB === null) return 0
                    if (valueA === null) return 1
                    if (valueB === null) return -1
                    return valueB - valueA
                })
            },
            async deleteKeywords() {
                console.log(this.selectedRows)
                if (!this.selectedRows.length) return
                const url =
                    (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                        this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                    ) == -1
                        ? process.env.VUE_APP_MONITORING_API_URL
                        : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/delete/keywords"
                const post_data = {
                    company_id: localStorage.company_id,
                    project_id: this.$route.params.id,
                    keywords: this.selectedRows,
                    user_id: localStorage.id
                }
                const response_data = await this.$helpers.axiosPost(url, post_data)
                this.fetchTrends({
                    sortDesc: this.sortDesc,
                    sortBy: this.sortBy,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage
                })
                this.deleteDialog = false
                this.selectedRows = []
                console.log(response_data.data)
                let notifidata = { label: "The selected keywords have been deleted successfully!", icon: "mdi-check-circle-outline", color: "primary" }
                this.$emit("notify", notifidata)
            },
            catUpdated() {
                this.showSwitchDialog = false
                this.fetchTrends({
                    sortDesc: this.sortDesc,
                    sortBy: this.sortBy,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage
                })
                this.selectedRows = []
                let notifidata = { label: "Category successfully changed!", icon: "mdi-check-circle-outline", color: "primary" }
                this.$emit("notify", notifidata)
            },
            onRowClick(row) {
                if (this.isSelecting) return
                console.log(row)
                let entryIndex = this.selectedRows.findIndex((e) => e._id == row._id)
                if (entryIndex === -1) {
                    this.selectedRows.push(row)
                } else {
                    this.selectedRows.splice(entryIndex, 1)
                }
            },
            setHeaderDateString() {
                let latestYearMonthHeader = this.headers.find((h) => h.id == 1)
                let lastYearMonthHeader = this.headers.find((h) => h.id == 2)
                let latestMonthString = this.trends[0].latestYearMonth.month + "/" + this.trends[0].latestYearMonth.year
                let latestYearMonthHeaderFilter = this.filterFields.find((h) => h.id == 1)
                let lastYearMonthHeaderFilter = this.filterFields.find((h) => h.id == 2)

                if (this.trends[0].latestYearMonth.month < 10) {
                    latestMonthString = "0" + latestMonthString
                }
                latestYearMonthHeader.text = "Google Searches " + latestMonthString
                let lastMonthString = this.trends[0].lastYearMonth.month + "/" + this.trends[0].lastYearMonth.year
                if (this.trends[0].lastYearMonth.month < 10) {
                    lastMonthString = "0" + lastMonthString
                }
                lastYearMonthHeader.text = "Google Searches " + lastMonthString

                latestYearMonthHeaderFilter.name = "Google Searches " + latestMonthString
                lastYearMonthHeaderFilter.name = "Google Searches " + lastMonthString
                const pad2 = (n) => (n < 10 ? "0" + n : "" + n)
                const addMonths = (m, delta) => {
                    // m: { month: 1-12, year: 20xx }
                    let y = m.year
                    let mm = m.month - 1 // 0-11
                    mm += delta
                    y += Math.floor(mm / 12)
                    mm = ((mm % 12) + 12) % 12
                    return { month: mm + 1, year: y }
                }

                const latest = this.trends[0].latestYearMonth
                const currStart = addMonths(latest, -11)
                const prevEnd = addMonths(latest, -12)
                const prevStart = addMonths(latest, -23)

                const current12Header = this.headers.find((h) => h.value === "latest_12_month_search_volume")
                const previous12Header = this.headers.find((h) => h.value === "prev_12_month_search_volume")

                if (current12Header) {
                    current12Header.text = `Google Searches ${pad2(currStart.month)}/${currStart.year} - ${pad2(latest.month)}/${latest.year}`
                }
                if (previous12Header) {
                    previous12Header.text = `Google Searches ${pad2(prevStart.month)}/${prevStart.year} - ${pad2(prevEnd.month)}/${prevEnd.year}`
                }
            },
            getSortObject(tableOptions) {
                let sort = {}
                console.log("tableOptions", tableOptions)
                if (tableOptions.sortBy.length && tableOptions.sortDesc.length) {
                    if (tableOptions.sortBy[0] == "latestYearMonth") {
                        sort["ads_data.monthly_searches.0.search_volume"] = tableOptions.sortDesc[0] ? -1 : 1
                    } else if (tableOptions.sortBy[0] == "lastYearMonth") {
                        sort["ads_data.monthly_searches.11.search_volume"] = tableOptions.sortDesc[0] ? -1 : 1
                    } else {
                        sort[tableOptions.sortBy[0]] = tableOptions.sortDesc[0] ? -1 : 1
                    }
                }
                sort.avg_search_volume = -1
                return sort
            }
        },
        watch: {
            // Beim Umschalten der Kategorisierung neu laden. Noetig auch dann, wenn
            // category_id unveraendert bleibt (Projektebene) und deshalb kein anderer Watcher feuert.
            taxonomyId() {
                this.fetchTrends({ sortDesc: this.sortDesc, sortBy: this.sortBy, page: this.page, itemsPerPage: this.itemsPerPage })
            },
            async exportData() {
                console.log("download triggered")
                console.log(this.trends)

                let fields = this.headers.map((header) => header.text)
                let rows = this.trends.map((trend) => {
                    let row = {}
                    this.headers.map((header) => {
                        if (header.value == "keyword") {
                            row[header.text] = header.id ? trend[header.value].search_volume : trend[header.value]
                        } else {
                            row[header.text] = header.id ? parseInt(trend[header.value].search_volume) : parseInt(trend[header.value])
                        }
                    })
                    return row
                })
                console.log(rows, fields)

                let post_data = {
                    rows: rows,
                    fields: fields,
                    fileTitle: "Trends_" + new Date().getTime().toLocaleString("de")
                }
                const url =
                    (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                        this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                    ) == -1
                        ? process.env.VUE_APP_MONITORING_API_URL
                        : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/export/csv"
                let response_data = await this.$helpers.axiosPost(url, post_data)
                window.location =
                    (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                        this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                    ) == -1
                        ? process.env.VUE_APP_MONITORING_API_URL
                        : process.env.VUE_APP_APIURL + "/monitoring-api") +
                    "/" +
                    response_data.data
            },
            search() {
                this.page = 1
                this.fetchTrends({
                    sortDesc: this.sortDesc,
                    sortBy: this.sortBy,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage
                })
            },
            category_id() {
                console.log(this.sortBy)
                this.fetchTrends({
                    sortDesc: this.sortDesc,
                    sortBy: this.sortBy,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage
                })
            }
        },
        mounted() {
            if (["1547", "2"].includes(this.company_id)) {
                this.headersData.find((e) => e.value == "latest_12_month_search_volume").visible = true
                this.headersData.find((e) => e.value == "prev_12_month_search_volume").visible = true
                this.headersData.find((e) => e.value == "avg_search_volume").visible = false
            }
        }
    }
</script>

<style>
    .blur {
        /* Add the blur effect */
        filter: blur(4px);
        -webkit-filter: blur(4px);
    }
    .intent div.v-progress-linear__determinate.primary {
        opacity: 0.9 !important;
    }
    #trendsTable th {
        white-space: nowrap !important;
    }
    #trendsTable .theme--light.v-data-table tbody tr.v-data-table__selected {
        background: #8dc4b936 !important;
    }
    #trendsTable table > tbody > tr:hover {
        cursor: pointer;
    }
    #trendsTable .internal-sv-change {
        display: inline-flex;
        align-items: center;
    }
    #trendsTable .internal-sv-change__value {
        font-size: 12px;
        line-height: 1;
        font-variant-numeric: tabular-nums;
        color: rgba(0, 0, 0, 0.72);
    }
    .theme--dark #trendsTable .internal-sv-change__value {
        color: rgba(255, 255, 255, 0.78);
    }
    #trendsTable .internal-sv-change__dash {
        font-size: 12px;
        line-height: 1;
        color: rgba(0, 0, 0, 0.38);
        margin-right: 2px;
    }
    .theme--dark #trendsTable .internal-sv-change__dash {
        color: rgba(255, 255, 255, 0.5);
    }
</style>
